import React, { useEffect } from "react";
import { Box, CardContent } from "@mui/material";
import {
  BorderGreyBox,
  CardSpg,
  handleSubmitValidationFail,
  isNotEmpty,
  useReactHookForm,
} from "@duosoftbg/nacid-components";
import { useTranslation } from "react-i18next";
import { useStore } from "react-redux";
import { vProfQualificationsSearchTable } from "../../../../../yup/schemas";
import useSearchTableControl from "../../../../../hooks/registers/search/useSearchTableControl";
import { FormProvider } from "react-hook-form";
import { SEARCH_FILTERS_GROUP } from "../../../../../config/registers/search/filters/groupsConfig";
import { searchProfessionalQualifications } from "../../../../../axios/api/services";
import SearchFilters from "../base/filters/SearchFilters";
import RecordNumberFilter from "../base/filters/definition/RecordNumberFilter";
import ApplicantFilter from "../base/filters/definition/ApplicantFilter";
import { IValProfQualificationSearch, ivalProfQualificationsSearch } from "../../../../../config/initialFormValues";
import ApplicationDateFilter from "../base/filters/definition/ApplicationDateFilter";
import RSearchProfessionalQualificationList from "./RSearchProfessionalQualificationList";
import ApplicationCountryNameFilter from "../base/filters/definition/ApplicationCountryNameFilter";
import RecognizedProfessionNameFilter from "../base/filters/definition/RecognizedProfessionNameFilter";
import ProfQualificationStatusFilter from "../base/filters/definition/ProfQualificationStatusFilter";
import DecisionNumberFilter from "../base/filters/definition/DecisionNumberFilter";
import { RootState } from "../../../../../store/redux/store";

const RSearchProfessionalQualification = () => {
  const { t } = useTranslation();
  const store = useStore();
  const group = SEARCH_FILTERS_GROUP.PROFESSIONAL_QUALIFICATION;

  const { methods } = useReactHookForm<IValProfQualificationSearch>({
    defaultValues: ivalProfQualificationsSearch,
    validationSchema: vProfQualificationsSearchTable,
  });

  useEffect(() => {
    const filtersData = (store.getState() as RootState).SearchData.searchTable[group].filtersData;
    if (isNotEmpty(filtersData)) {
      methods.reset(filtersData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const control = useSearchTableControl({
    group,
    methods,
    initialValues: ivalProfQualificationsSearch,
    filterData: searchProfessionalQualifications,
    callAfterResetFilters: true,
  });

  return (
    <FormProvider {...methods}>
      <form
        onSubmit={methods.handleSubmit(
          () => control.handleSubmitFilters(),
          () => handleSubmitValidationFail(methods.formState, t, undefined),
        )}
      >
        <CardSpg my={4} style={{ overflow: "visible" }}>
          <CardContent style={{ position: "relative" }}>
            <Box>
              <BorderGreyBox>
                <SearchFilters
                  isSubmitBtnDisabled={control.isSubmitBtnDisabled}
                  isResetBtnDisabled={control.isResetBtnDisabled}
                  handleResetFilters={control.handleResetFilters}
                >
                  <RecordNumberFilter />
                  <ApplicantFilter />
                  <ApplicationDateFilter />
                  <ApplicationCountryNameFilter />
                  <RecognizedProfessionNameFilter />
                  <DecisionNumberFilter />
                  <ProfQualificationStatusFilter />
                </SearchFilters>
              </BorderGreyBox>
              {control.showList && (
                <RSearchProfessionalQualificationList
                  records={control.records}
                  total={control.total}
                  isLoading={control.isLoading}
                  onPageOrOrderChange={control.handlePageOrOrderChange}
                  blockTable={control.blockTable}
                  group={group}
                  viewURL={"/professional-qualifications/view?id="}
                />
              )}
            </Box>
          </CardContent>
        </CardSpg>
      </form>
    </FormProvider>
  );
};

export default RSearchProfessionalQualification;
